import { Breadcrumb } from "pepsico-ds";
import UserLimitSettingsForm from "../../../components/management/UserLimitSettings/UserLimitSettingsForm";
import { paths } from "../../../routes/paths";

export default function UserLimitSettingsEditPage() {
  return (
    <div className="container">
      <div className="wrap">
        <Breadcrumb
          breadcrumbs={[
            {
              label: "System Setting",
              href: `../../${paths.system_setting}`,
            },
            {
              label: "Edit User Limit Settings",
              href: `../../${paths.system_setting}/${paths.user_limit_settings_edit}`,
            },
          ]}
          activeIndex={1}
        />
        <div className="heading-wrap">
          <h2>User Limit Settings</h2>
        </div>
        <div className="user-limit-settings-form">
          <UserLimitSettingsForm isEditPage={true} />
        </div>
      </div>
    </div>
  );
}
